export function preventDefault(e: { preventDefault: () => void }) {
	e.preventDefault();
}
